import { TodoSubType } from 'views/Conversation/Sider/ToDoBundle/FormItem';
import { Panel } from './Panel';
import { useTranslate } from '@tolgee/react';
import { useMemo } from 'react';
import { TypeSource } from 'views/Conversation/Sider/ToDoBundle/NewTodo';
import { SubTypes as SubTypesType } from './NewTicket/NewSelectType';
import { UseTicketListParams, useUpdateTodoMutation } from 'hooks/business/chat/useTicketMutations';

interface SubTypesProps {
  id: string;
  typeSource: TypeSource;
  type: Todo.Type;
  listParams: UseTicketListParams | null;
  subType: SubTypesType;
  readonly?: boolean;
}

export const SubTypes = (props: SubTypesProps) => {
  const { id, typeSource, type, listParams, subType, readonly = false } = props;
  const { t } = useTranslate();

  const { mutate: updateTodo } = useUpdateTodoMutation(listParams);

  const handleChangeSubType = (value: SubTypesType) => {
    const [subType1, subType2, subType3] = value;
    updateTodo({ id, subType: subType1, subType2, subType3 });
  };

  const subTypeOptions = useMemo(() => {
    const result = typeSource.find((e) => e.type === type)?.subTypeTrees || [];
    return result;
  }, [typeSource, type]);

  if (readonly) {
    const subTypeString = subType.filter((e) => !!e).join(' / ');
    if (subTypeString) {
      return (
        <Panel title={t('st_3')}>
          <div className="p-3 bg-[#F7F9FA] rounded">{subType.filter((e) => !!e).join(' / ')}</div>
        </Panel>
      );
    } else {
      return null;
    }
  }

  if (subTypeOptions.length === 0) {
    return null;
  }

  return (
    <Panel title={t('st_3')}>
      <TodoSubType
        className="!w-full"
        dataSource={subTypeOptions}
        value={subType.filter((e) => !!e) as string[]}
        onChange={(value) => {
          handleChangeSubType(value as SubTypesType);
        }}
      />
    </Panel>
  );
};
